// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FaHome, FaTimes  } from "react-icons/fa";
// import { Divider } from "@mui/material";
// import "./Sidebar.css";
// import logo from "../Assets/BooksCompl.png";

// const EmployeeSidebar = ({ sidebarOpen, setSidebarOpen }) => {
//   const location = useLocation(); // Get current route

//   return (
//     <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
//       {/* Close Button (Mobile Only) */}
//       <button className="close-btn" onClick={() => setSidebarOpen(false)}>
//         <FaTimes />
//       </button>

//       <div className="logo-container">
//         <img src={logo} alt="Logo" className="sidebar-logo" />
//       </div>

//       <Divider sx={{ bgcolor: "white", my: 2 }} />

//       <ul className="nav-links">
//         <li className={location.pathname === "/dashboard" ? "active" : ""}>
//           <Link to="/dashboard"><FaHome /> Dashboard</Link>
//         </li>
//       </ul>
//     </aside>
//   );
// };

// export default EmployeeSidebar;

import { Link, useLocation } from "react-router-dom";
import { FaHome, FaTimes, FaStar } from "react-icons/fa";
import { Divider } from "@mui/material";
import "./Sidebar.css";
import defaultAvatar from "../Assets/forget.png"; // Add a default avatar image

const EmployeeSidebar = ({ sidebarOpen, setSidebarOpen, employee }) => {
  const location = useLocation();

  // Calculate average feedback rating
  const calculateAverageRating = () => {
    if (!employee?.clients || employee.clients.length === 0) return 0;
    
    const totalRatings = employee.clients.reduce((sum, client) => {
      return sum + (client.feedback?.rating || 0);
    }, 0);
    
    return (totalRatings / employee.clients.length).toFixed(1);
  };

  const averageRating = calculateAverageRating();

  return (
    <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
      {/* Close Button (Mobile Only) */}
      <button className="close-btn" onClick={() => setSidebarOpen(false)}>
        <FaTimes />
      </button>

       {/* Employee Profile Section */}
       <div className="employee-profile">
        <img 
          src={employee?.profileImage || defaultAvatar} 
          alt="Employee" 
          className="employee-avatar" 
        />
        <h3 className="employee-name">{employee?.name || "Employee"}</h3>
        
        <div className="employee-rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <FaStar 
                key={i} 
                className={i < Math.floor(averageRating) ? "filled" : ""} 
              />
            ))}
          </div>
          <span className="rating-text">
            {averageRating} ({employee?.clients?.length || 0} clients)
          </span>
        </div>
      </div>

      <Divider sx={{ bgcolor: "white", my: 2 }} />

      <ul className="nav-links">
        <li className={location.pathname === "/client" ? "active" : ""}>
          <Link to="/client"><FaHome /> Dashboard</Link>
        </li>
      </ul>

    </aside>
  );
};

export default EmployeeSidebar;
